import Container from 'react-bootstrap/Container';
import { useTranslation } from 'react-i18next';
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/Header';
import LanguageSelector from '../components/LanguageSelector';

const Start = () => {
  const { t } = useTranslation('commons');
  return (
    (
      <Fragment>
        <Header>
          <LanguageSelector />
        </Header>
        <Container className="mt-4">
          <div className="shadow px-3 py-4 mb-5 bg-white">
            <h3 className="font-weight-bold">{t('surveyCoverHeader')}</h3>
            <h5 className="mt-4">{t('surveyCover')}</h5>
            <div className="mt-4">
              <Link to={location => `${location.pathname}/1`} className="btn btn-primary">English</Link>
              <Link to={location => `${location.pathname}/1?language=es`} className="ml-2 btn btn-primary">Español</Link>
            </div>
          </div>
        </Container>
      </Fragment>
    )
  );
};

export default Start;
